import * as React from "react"

import { CommonFilters } from "@components"
import { COMMON_FILTER_KEYS } from "../../@constants"


export default function CommonFiltersCatalogue({ components={}, compProps={}, userFilters, isLoadingDefaultFilters, ...props }) {

    return <CommonFilters
		components={{
			country: true, site: true,
			googleCategory: true, brandCustomer: true, favFilters: true,
			favFiltersOnlyLine: true, ...components
		}}
		compProps={{
			country: { grid: { md: 6 } },
			site: { grid: { md: 6 } },
			googleCategory: { grid: { md: 6 } },
			brandCustomer: { grid: { md: 6 } },
			favFilters: {
				allowedFilters: [COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND]
			},
			...compProps
		}}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
		defaultValues={userFilters}
		{...props}
	/>
}